<template>
  <div class="d-flex flex-column pa-4 align-center ga-4 share-area" ref="shareArea" :style="{backgroundColor: color.background.value}">
    <div class="d-flex flex-column ga-2 align-center text-center">
      <v-avatar size="60" :image="image" :icon="PlaceholderIcon" color="BW-200" v-if="image"/>
      <div class="d-flex flex-column ga-1 align-center">
        <div class="title" v-if="name" :style="{color: color.color.value}">{{name}}</div>
        <div class="alias" :style="{color: color.color.value}">{{link}}</div>
      </div>
    </div>
    <div class="qr-block pa-4 mb-2 main-qr">
      <ClientOnly>
        <QRCodeVue3 myclass="qr" :value="link" :key="defQRKey" :width="168" :height="168"
                    :image="qImage"
                    :image-options="imageOptions"
                    :dots-options="{ type: 'extra-rounded', color: qColor, roundSize: true, gradient: null }"
                    :corners-dot-options="{ type: '', color: qColor }"
                    :corners-square-options="{ type: 'extra-rounded', color: qColor}"/>
      </ClientOnly>
    </div>
  </div>
</template>

<script setup lang="ts">
import PlaceholderIcon from "~/assets/icons/placeholder.vue";
import QRCodeVue3 from "qrcode-vue3";
import {computed, onMounted, ref, watch} from "vue";
import {useBGColor} from "@/composables/useBGColor";

const props = defineProps({
  alias: { type: String },
  name: { type: String },
  image: { type: String },
  link: { type: String },
  qColor: { type: String },
  qImage: { type: String },
  bColor: { type: String },
});

const color = useBGColor()

const imageOptions = {
  hideBackgroundDots: true,
  imageSize: 0.4,
  margin: 6
}

const defQRKey = computed(() => {
  return `${props.link}-${props.qImage?.length || 0}-${props.bColor}-${props.qColor}`
})

const downloadPNG = () => {
  const img = document.querySelector('.main-qr img');
  if (!img) return;

  const link = document.createElement('a');
  link.download = 'qrcode.png';
  link.href = img.src;
  link.click();
}

const shareArea = ref(null);
const shareFile = ref(null);
const shareInProgress = ref(false);
const initFile = async () => {
  if (!shareArea.value) return;
  shareInProgress.value = true

  const html2canvas = (await import('html2canvas')).default;

  const canvas = await html2canvas(shareArea.value, {
    logging: false,
    useCORS: true,
    scale: 2,
    onclone: (clonedDoc) => {
      const clonedElement = clonedDoc.querySelector('.share-area');
      if (clonedElement) {
        clonedElement.style.borderRadius = '0';
      }
    }
  });

  const blob = await new Promise((resolve) => {
    canvas.toBlob((result) => resolve(result), 'image/png');
  })
  shareFile.value = new File([blob], 'result.png', { type: 'image/png' });
  shareInProgress.value = false
}

onMounted(() => {
  color.setBGColor(props.bColor)
})

watch(() => props.bColor, (n) => {
  color.setBGColor(props.bColor)
})

defineExpose({
  downloadPNG,
  initFile,
  shareFile,
  shareInProgress
});
</script>

<style scoped lang="sass">
.title
  color: #FFF
  font-size: 16px
  font-weight: 600
  line-height: normal
.alias
  overflow: hidden
  white-space: nowrap
  color: #FFF
  text-overflow: ellipsis
  font-size: 13px
  font-weight: 400
  line-height: normal

.share-area
  border-radius: 16px

.qr-block
  background: #fff
  width: fit-content
  border-radius: 16px
  min-height: 200px
  min-width: 200px
  ::v-deep
    .qr
      display: flex
</style>
